module.exports = __webpack_public_path__ + "2a3ab84b091fe5836902762b72976ffb.png";